import { render, staticRenderFns } from "./ModalSelectSticker.vue?vue&type=template&id=254cfe84&scoped=true&"
import script from "./ModalSelectSticker.vue?vue&type=script&lang=js&"
export * from "./ModalSelectSticker.vue?vue&type=script&lang=js&"
import style0 from "./ModalSelectSticker.vue?vue&type=style&index=0&id=254cfe84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254cfe84",
  null
  
)

export default component.exports